/**
 * UA는 위조 가능하므로 보안 경계가 아닌 1차 필터로만 사용하고,
 * Flutter 브릿지 검증과 함께 써야 한다.
 */
export function detectWebView(ua: string = navigator.userAgent): boolean {
  const isAndroidWebView = /;\s*wv\)/.test(ua)
  const isFlutter = /Flutter/i.test(ua)
  const isIOSWebView = /iPhone|iPad|iPod/.test(ua) && /Mobile/.test(ua) && !/Safari\//.test(ua)

  return isAndroidWebView || isFlutter || isIOSWebView
}
